import { writeConfigFields } from './settings-fields';

/** `PATCH /client/config/fields`: root `abandonment_reasons`. */
export const editAbandonmentReasons = async (reasons: string[]): Promise<any> =>
  writeConfigFields({ abandonment_reasons: reasons });
